/**
 * Email Signup Block Component
 *
 * Handles dynamic padding adjustment for email signup input fields
 * when integrated buttons have variable widths.
 */
// Ajuste: esta sección se agrega en este proyecto en más de un lugar
// por página (ej. footer + una sección de newsletter en el home). El
// bloque emite su propio <script src="email-signup.js"> por cada
// instancia, y "class EmailSignupBlock" es una declaración léxica de
// alcance global — si el archivo se ejecuta dos veces en la misma
// página, el navegador tira "Identifier already declared" porque a
// diferencia de una función, una clase no se puede redeclarar en el
// mismo scope aunque venga de dos <script> distintos. Se envuelve todo
// en un IIFE para que cada ejecución quede en su propio scope y no
// choque con la siguiente.
(function () {
  if (customElements.get('email-signup-block')) return;

  class EmailSignupBlock extends HTMLElement {
    constructor() {
      super();
      /** @type {number} */
      this.lastButtonWidth = 0;
      /** @type {ResizeObserver | undefined} */
      this.observer = undefined;

      this.adjustInputPadding = this.adjustInputPadding.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.email-signup__button--integrated');
      this.input = this.querySelector('.email-signup__input');
      this.inputGroup = this.querySelector('.email-signup__input-group');

      const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

      if (this.button && this.input && this.inputGroup && isTextButton) {
        this.adjustInputPadding();

        this.observer = new ResizeObserver(() => {
          this.adjustInputPadding();
        });
        this.observer.observe(this.button);

        if ('fonts' in document) {
          document.fonts.ready.then(() => {
            this.adjustInputPadding();
          });
        }
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    adjustInputPadding() {
      if (!this.button || !this.inputGroup) return;

      const buttonWidth = /** @type {HTMLElement} */ (this.button).offsetWidth;

      if (buttonWidth !== this.lastButtonWidth) {
        this.lastButtonWidth = buttonWidth;
        /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${buttonWidth}px`);
      }
    }
  }

  customElements.define('email-signup-block', EmailSignupBlock);
})();
